import { connect } from 'react-redux';

import RegionModal, {
  RegionModalStateProps,
  RegionModalDispatchProps,
} from '../components/RegionModal';
import { StoreState } from '../reducers';
import { initJanus } from '../actionCreators';

const mapStateToProps = ({ qb }: StoreState): RegionModalStateProps => ({
  error: qb.error,
  loading: qb.loading,
});

const mapDispatchToProps: RegionModalDispatchProps = { initJanus };

export default connect(mapStateToProps, mapDispatchToProps)(RegionModal);
